import { render, staticRenderFns } from "./salemessage.vue?vue&type=template&id=aaadd8c2&"
import script from "./salemessage.vue?vue&type=script&lang=js&"
export * from "./salemessage.vue?vue&type=script&lang=js&"
import style0 from "./salemessage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports